import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';

interface EmailReminderEvent {
  event: 'created' | 'updated' | 'deleted';
  data: any;
}

interface UseEmailReminderSocketParams {
  onEvent: (event: EmailReminderEvent) => void;
  enabled?: boolean;
}

/**
 * Custom hook to connect to WebSocket and listen for email reminder events
 */
export function useEmailReminderSocket({ onEvent, enabled = true }: UseEmailReminderSocketParams) {
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Connect to Socket.IO server
    const socket = io({
      path: '/socket.io/',
      transports: ['websocket', 'polling'],
      withCredentials: true,
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('WebSocket connected:', socket.id);
    });

    socket.on('disconnect', () => {
      console.log('WebSocket disconnected');
    });

    socket.on('emailReminder', (data: EmailReminderEvent) => {
      console.log('Received emailReminder event:', data);
      onEvent(data);
    });

    socket.on('connect_error', (error) => {
      console.error('WebSocket connection error:', error);
    });

    // Cleanup on unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [enabled, onEvent]);

  return socketRef.current;
}
